import FloorPlan from '@spa/shared/svg/floor-plan';
import MiniCamera from '@spa/shared/svg/mini-camera';
import YoutubeAlternative from '@spa/shared/svg/youtube-alternative';
export var PHOTOS_MODAL_SECTIONS = {
  photos: {
    label: 'Photos',
    icon: MiniCamera
  },
  video: {
    label: 'Video',
    icon: YoutubeAlternative
  },
  floor_plan: {
    label: 'Floor plan',
    icon: FloorPlan
  },
  carousel: {
    label: 'Carousel'
  }
};